import {EnrollTrackRole} from 'Users/models/User/EnrollmentTrackingUserType';

export class HomeOfficeUserType {
  public readonly key = 'HomeOfficeUserType';
  public readonly enrollTrackRole = EnrollTrackRole.HomeOffice;
}
